import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import DecisionSupportPage from "@/pages/products/DecisionSupportPage";

export const Route = createFileRoute("/products/decision-support")({
  head: () => pageHead("AI Decision Support Systems", "Custom AI decision support built around your domain knowledge, operational data, and decision workflows, with human oversight.", "/products/decision-support", false),
  component: DecisionSupportPage,
});
